module.exports = "<span ng-message=max>*Must be a past date</span> ";